import { TRACKING_UPDATE } from '../actions/tracking.js'

export default function tracking(state, action) {
	switch (action.type) {
		case TRACKING_UPDATE: {
			return { ...state, ...action.payload }
		}

		default: {
			return state
		}
	}
}
